import React from "react";

const Facilities = () => {
  return (
    <>
      <div className="container-fluid p-0">
        <div className="container liscontainer">
          <div className="facilitycontent">
            {/* swimming */}
            <div className="facilitCard">
              <div className="facilimages">
                <img src="./b1.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">LABORATORIES</div>
                <p>
                Our school provides highly equipped laboratories for practical learning in Physics, Chemistry, and Biology. Each lab is enhanced with instructive charts and models to facilitate a better understanding of the subject matter.
                <br />  
                The Biology Lab features its own museum, where various specimens are carefully preserved for educational purposes. These resources help students gain hands-on experience and deepen their scientific knowledge.  <br /> 
                </p>
              </div>
            </div>

            {/* skilled */}

            <div className="facilitCard">
              <div className="facilimages">
                <img src="./b2.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">
                CULTURAL ACTIVITIES</div>
                <p>
                To nurture aesthetic skills and values, our school offers specialized teachers for various disciplines of music, including vocal and instrumental training.

                <br /> 
                 Additionally, we arrange documentary film screenings to instill moral values and provide students with meaningful learning experiences beyond academics.  <br /> 
                </p>
              </div>
            </div>

            {/* sports */}
            <div className="facilitCard">
              <div className="facilimages">
                <img src="./b3.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">HOUSE SYSTEM</div>
                <p>
                To foster healthy competition and team spirit, our school follows a house system, dividing students into three houses:
              
                <ul>
                  <li>Honest House</li>
                  <li>Noble House</li>
                  <li>Pious House</li>
                </ul>
                This system encourages students to engage in various activities, helping them develop a well-rounded personality and grow into responsible citizens of the country.
                </p>
              </div>
            </div>

            {/* nice Infrastructure */}

            <div className="facilitCard">
              <div className="facilimages">
                <img src="./b4.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">LIBRARY</div>
                <p>
                A well-stocked library is essential for fostering independent learning and research skills. Our spacious library houses over 20,000 books and periodicals across various subjects.


                <br /> 
                
                With the guidance of trained librarians, students can enhance their reading habits and develop strong research abilities. <br />



                </p>
              </div>
            </div>

            {/* hygiene washroom */}
            <div className="facilitCard">
              <div className="facilimages">
                <img src="./b5.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">COMPUTER EDUCATION</div>
                <p>
                Computer skills are an integral part of our regular curriculum, starting from primary classes. We provide both theoretical and practical knowledge to ensure students gain proficiency in modern technology.
                </p>
              </div>
            </div>

            {/* Good Academic */}

            <div className="facilitCardsports">
              <div className="facilimages sportimg">
                <img  src="./b6.png" alt="#" />
              </div>
              <div className="facontent">
                <div className="factitle">SPORTS</div>
                <p>
                Sports are an essential part of holistic education. Our school offers top-notch facilities for:

                <ul>
                  <li> Athletics (Track & Field)</li>
                  <li>Cricket</li>
                  <li>Football</li>
                  <li>Hockey</li>
                  <li>Lawn Tennis</li>
                  <li>Table Tennis</li>
                  <li>Badminton</li>
                  <li>Martial Arts (including SQAY Martial Arts)</li>
                </ul>


                Qualified instructors and coaches train students, motivating them to compete at District, Division, State, National, and International levels.
                <br /> 

We take immense pride in our students' achievements. Recently, some of our students represented India in Sri Lanka at a SQAY Martial Arts competition and won gold medals, bringing laurels to the school.
<br /> 
                </p>
              </div>
            </div>

            {/* transport facility */}

            {/* <div className="facilitCard">
              <div className="facilimages">
                <img src="./transport.png" alt="" />
              </div>
              <div className="facontent">
                <div className="factitle">Transport Facility</div>
                <p>
                  The school provides transport facility to the students through
                  Buses & Magic for transporting the students from different
                  localities to the school and vice-versa. Students can avail
                  the Transport facility by putting up an application. All the
                  buses have trained driver’s and conductor’s. The school
                  follows all the rules and regulations of M.P. Government for
                  the buses.
                </p>
              </div>
            </div> */}

            {/* smart education fac 

            <div className="facilitCard">
              <div className="facilimages">
                <img src="./statescience.jpg" alt="" />
              </div>
              <div className="facontent">
                <div className="factitle">
                  State of the Science, Chemistry, Biology and Physics
                </div>
                <p>
                  {" "}
                  With a vision to 'Cultivate one Million children in India as
                  Neoteric Innovators', Atal Innovation Mission is establishing
                  Atal Tinkering Laboratories (ATLs) in schools across India.{" "}
                </p>
              </div>
            </div>  */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Facilities;
